;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .factory('JiraBugtrackerService', JiraBugtrackerService)

  function JiraBugtrackerService(
    $q,
    $location,
    UserService,
    ServiceUtils,
    BugtrackerFactory,
    JIRA_FIELD_TYPES,
    FILTER_GROUPS,
    BUGTRACKER_DEFAULT_TEST_NAME
  ) {
    'ngInject'

    return {
      fillAdditionalJIRAFields: fillAdditionalJIRAFields,
      addNewAdditionalField: addNewAdditionalField,
      consolidateSelectFields: consolidateSelectFields,
      includeTemplate: includeTemplate,
      getJiraBugtrackerForVulnerability: getJiraBugtrackerForVulnerability,
      getJiraBugtrackerForLibrary:
        BugtrackerFactory.getJiraBugtrackerForLibrary,
      buildJiraBugtrackerSettings: buildJiraBugtrackerSettings,
      getJiraPriorityByTraces: getJiraPriorityByTraces,

      addJiraBugtracker: addJiraBugtracker,
      testJiraBugtracker: testJiraBugtracker,
      testExistingJiraBugtracker: testExistingJiraBugtracker,
      editJiraBugtracker: editJiraBugtracker,

      getJiraPriorities: getJiraPriorities,
      getJiraResolutions: getJiraResolutions,
      getJiraProjects: getJiraProjects,
      getJiraUsers: getJiraUsers,
      getJiraLabels: getJiraLabels,
      getJiraFields: getJiraFields,
      getJiraStatuses: getJiraStatuses,
      getJiraIssueTypes: getJiraIssueTypes,

      buildJiraBugtrackerBaseProperties: buildJiraBugtrackerBaseProperties,
      buildJiraBugtrackerProperties: buildJiraBugtrackerProperties,
      addJiraIntegration: addJiraIntegration,
      buildJiraIntegration: buildJiraIntegration,
      buildJiraFields: buildJiraFields,
      buildJiraIntegrationTest: buildJiraIntegrationTest,
      buildJiraTwoWayIntegration: buildJiraTwoWayIntegration,
      getUrl: getUrl,

      convertLabelsValuesToAllowedValues: convertLabelsValuesToAllowedValues
    }

    function getJiraPriorities(request, id) {
      if (id) {
        return BugtrackerFactory.getJiraPrioritiesByBugtracker(id, request)
      }
      return BugtrackerFactory.getJiraPriorities(request)
    }

    function getJiraResolutions(request, id) {
      if (id) {
        return BugtrackerFactory.getJiraResolutionsByBugtracker(id, request)
      }
      return BugtrackerFactory.getJiraResolutions(request)
    }

    function getJiraProjects(request, id) {
      if (id) {
        return BugtrackerFactory.getJiraProjectsByBugtracker(id, request)
      }
      return BugtrackerFactory.getJiraProjects(request)
    }

    function getJiraUsers(request, projectKey, id) {
      if (id) {
        return BugtrackerFactory.getJiraUsersByBugtracker(
          id,
          request,
          projectKey
        )
      }
      return BugtrackerFactory.getJiraUsers(request, projectKey)
    }

    function getJiraLabels(request) {
      return BugtrackerFactory.getJiraLabels(request)
    }

    function getJiraFields(request, projectKey, issueTypeID, id) {
      if (id) {
        return BugtrackerFactory.getJiraFieldsByBugtracker(
          id,
          request,
          projectKey,
          issueTypeID
        )
      }
      return BugtrackerFactory.getJiraFields(request, projectKey, issueTypeID)
    }

    function getJiraIssueTypes(request, projectKey, id) {
      if (id) {
        return BugtrackerFactory.getJiraIssueTypesByBugtracker(
          id,
          request,
          projectKey
        )
      }
      return BugtrackerFactory.getJiraIssueTypes(request, projectKey)
    }

    function getJiraStatuses(request, projectKey, id) {
      if (id) {
        return BugtrackerFactory.getJiraStatusesByBugtracker(
          id,
          request,
          projectKey
        )
      }
      return BugtrackerFactory.getJiraStatuses(request, projectKey)
    }

    function getJiraPriorityByTraces(bugtrackerId, traces, appId) {
      return BugtrackerFactory.getJiraPriorityByTraces(
        bugtrackerId,
        traces,
        appId
      )
    }

    function buildJiraBugtrackerSettings(vm, data) {
      vm.select.projects = data.settings.projects
      vm.select.priorities = data.settings.priorities
      vm.select.assignees = data.settings.assignees
      vm.select.issue_types = data.settings.issue_types
      vm.selected_fields = angular.copy(data.bugtracker.fields)
      vm.properties = _buildJiraBugtrackerProperties(data.bugtracker, vm.select)

      fillAdditionalJIRAFields(vm, vm.properties.issue_type)

      vm.select.required_fields = _.union(
        vm.select.required_fields,
        vm.select.additional_fields
      )

      _generatePairedFields(vm)
    }

    function convertLabelsValuesToAllowedValues(selectedValues) {
      var selectedValuesArray = selectedValues.split(',')
      var allowedValuesArray = []
      selectedValuesArray.forEach(function (selectedValue) {
        allowedValuesArray.push({ id: selectedValue, name: selectedValue })
      })
      return allowedValuesArray
    }

    function _buildJiraBugtrackerProperties(settings, select) {
      var properties = {}
      properties.project = _.find(select.projects, {
        id: settings.project
      })
      properties.assignee = _.find(select.assignees, {
        key: settings.assignee
      })
      properties.issue_type = _.find(select.issue_types, {
        id: parseInt(settings.issue_type)
      })
      properties.priority_critical = _.find(select.priorities, {
        name: settings.priority_critical
      })
      properties.priority_high = _.find(select.priorities, {
        name: settings.priority_high
      })
      properties.priority_medium = _.find(select.priorities, {
        name: settings.priority_medium
      })
      properties.priority_low = _.find(select.priorities, {
        name: settings.priority_low
      })
      properties.priority_note = _.find(select.priorities, {
        name: settings.priority_note
      })

      return properties
    }

    function getJiraBugtrackerForVulnerability(bugtrackerId, appId) {
      return BugtrackerFactory.getJiraBugtrackerForVulnerability(
        bugtrackerId,
        appId
      )
    }

    function fillAdditionalJIRAFields(vm, issueType) {
      vm.select.fields = []

      if (issueType.fields && issueType.fields.length > 0) {
        vm.select.fields = issueType.fields
      }

      _fillPropertiesFields(vm, vm.select.fields)
    }

    function addNewAdditionalField(vm) {
      var availableField = _getNextAvailableField(vm)
      var additionalField = _createCustomizedField(
        availableField,
        vm.select.available_fields
      )
      vm.select.additional_fields.push(additionalField)
    }

    function consolidateSelectFields(vm) {
      var selectFields = _getSelectFields(vm)

      _.each(vm.select.additional_fields, function (additionalField) {
        additionalField.select_fields = _.union(selectFields, [
          additionalField.field
        ])
      })
    }

    function includeTemplate(field) {
      var pathTemplates = 'views/settings/integrations/template/fields/'
      if (field.empty) {
        return pathTemplates + 'empty.tpl.html'
      } else if (
        angular.isUndefined(field) ||
        angular.isUndefined(field.schema)
      ) {
        return pathTemplates + 'undefined.tpl.html'
      } else if (field.schema.type === JIRA_FIELD_TYPES.USER) {
        return pathTemplates + 'user.tpl.html'
      } else if (field.schema.type === JIRA_FIELD_TYPES.PRIORITY) {
        return pathTemplates + 'priority.tpl-modal.html'
      } else if (
        field.schema.type === JIRA_FIELD_TYPES.ARRAY &&
        field.key === 'labels'
      ) {
        return pathTemplates + 'labels-multiple-modal.tpl.html'
      } else if (
        field.schema.type === JIRA_FIELD_TYPES.ARRAY &&
        field.allowedValues
      ) {
        return pathTemplates + 'allowedvalues-multiple-modal.tpl.html'
      } else if (field.allowedValues && field.allowedValues.length > 0) {
        return pathTemplates + 'allowedvalues-modal.tpl.html'
      } else if (
        field.schema.type === JIRA_FIELD_TYPES.STRING &&
        field.schema.custom &&
        field.schema.custom.endsWith(JIRA_FIELD_TYPES.URL)
      ) {
        return pathTemplates + 'url.tpl.html'
      } else if (
        field.schema.type === JIRA_FIELD_TYPES.STRING ||
        field.schema.type === JIRA_FIELD_TYPES.TIME_TRACKING ||
        field.schema.type === JIRA_FIELD_TYPES.ANY
      ) {
        return pathTemplates + 'string.tpl.html'
      } else if (field.schema.type === JIRA_FIELD_TYPES.NUMBER) {
        return pathTemplates + 'number.tpl.html'
      } else if (field.schema.type === JIRA_FIELD_TYPES.ARRAY) {
        field.array_values = []
        return pathTemplates + 'array.tpl.html'
      } else if (field.schema.type === JIRA_FIELD_TYPES.DATETIME) {
        return pathTemplates + 'datetime.tpl.html'
      } else if (field.schema.type === JIRA_FIELD_TYPES.DATE) {
        return pathTemplates + 'date.tpl.html'
      } else if (field.schema.type === JIRA_FIELD_TYPES.ISSUELINK) {
        return pathTemplates + 'string.tpl.html'
      } else {
        return pathTemplates + 'not-implemented.tpl.html'
      }
    }

    function _fillPropertiesFields(vm, fields) {
      vm.select.required_fields = []
      vm.select.additional_fields = []

      var requiredFields = _.filter(fields, { required: true })
      _.each(requiredFields, function (field) {
        var selectFields = [field]
        var requiredField = _createCustomizedField(field, selectFields)
        _setSelectedValueToRequiredField(vm, requiredField, field)
        vm.select.required_fields.push(requiredField)
      })

      vm.select.available_fields = _.filter(fields, { required: false })
      if (vm.selected_fields && vm.selected_fields.length > 0) {
        _addSelectedAdditionalFields(vm)
      }

      consolidateSelectFields(vm)
    }

    function _generatePairedFields(vm) {
      vm.select.paired_fields = []

      for (var i = 0; i < vm.select.required_fields.length; i += 2) {
        vm.select.paired_fields.push([
          vm.select.required_fields[i],
          vm.select.required_fields[i + 1]
        ])
      }
    }

    function _createCustomizedField(field, selectFields) {
      return {
        field: field,
        template: includeTemplate(field),
        select_fields: selectFields,
        values: [],
        openedDatepicker: false
      }
    }

    function _setSelectedValueToRequiredField(vm, customizedField, jiraField) {
      if (vm.selected_fields && vm.selected_fields.length > 0) {
        var selectedField = _.find(vm.selected_fields, {
          key: jiraField.key
        })
        if (selectedField) {
          _setSelectedValue(customizedField, jiraField, selectedField)
        }
      }
    }

    function _addSelectedAdditionalFields(vm) {
      _.each(vm.selected_fields, function (selectedField) {
        var availableField = _.find(vm.select.available_fields, {
          key: selectedField.key
        })
        if (availableField) {
          var additionalField = _createCustomizedField(
            availableField,
            vm.select.available_fields
          )
          _setSelectedValue(additionalField, availableField, selectedField)
          vm.select.additional_fields.push(additionalField)
        }
      })
    }

    function _setSelectedValue(customizedField, jiraField, selectedField) {
      var date

      if (
        jiraField.schema.type === JIRA_FIELD_TYPES.ARRAY &&
        selectedField.value &&
        jiraField.allowedValues
      ) {
        if (jiraField.key === 'labels') {
          //add selected values to allowed values
          var combinedArray = customizedField.field.allowedValues.concat(
            convertLabelsValuesToAllowedValues(selectedField.value)
          )
          customizedField.field.allowedValues = combinedArray.filter(function (
            item,
            index
          ) {
            return combinedArray.indexOf(item) === index
          })
        }

        var values = []
        _.each(selectedField.value.split(','), function (fieldValue) {
          var selectedValue = _.find(jiraField.allowedValues, {
            name: fieldValue
          })

          if (!selectedValue) {
            selectedValue = _.find(jiraField.allowedValues, {
              id: fieldValue
            })
          }

          if (selectedValue) {
            values.push(selectedValue)
          }
        })
        selectedField.value = _.map(values, JIRA_FIELD_TYPES.NAME).join()
        customizedField.values = values
      } else if (
        jiraField.schema.type === JIRA_FIELD_TYPES.ARRAY &&
        selectedField.value
      ) {
        customizedField.values = selectedField.value.split(',')
      } else if (
        (jiraField.schema.type === JIRA_FIELD_TYPES.USER ||
          jiraField.allowedValues) &&
        selectedField.value
      ) {
        var selectedValue = undefined
        var selectedDisplayName = undefined
        var selectedItem = _.find(jiraField.allowedValues, {
          name: selectedField.value
        })

        if (!selectedItem) {
          selectedItem = _.find(jiraField.allowedValues, {
            id: selectedField.value
          })
        }

        if (selectedItem) {
          selectedValue = selectedItem.id
          selectedDisplayName = selectedItem.name
        }

        selectedField.value = selectedValue
        customizedField.value = selectedValue
        selectedField.displayName = selectedDisplayName
        customizedField.displayName = selectedDisplayName
      } else if (
        jiraField.schema.type === JIRA_FIELD_TYPES.NUMBER &&
        selectedField.value
      ) {
        customizedField.value = parseInt(selectedField.value)
      } else if (
        jiraField.schema.type === JIRA_FIELD_TYPES.DATE &&
        selectedField.value
      ) {
        date = new Date(parseInt(selectedField.value) * 1000)
        if (_isValidDate(date)) {
          customizedField.value = date
        } else {
          customizedField.value = new Date()
        }
      } else if (
        jiraField.schema.type === JIRA_FIELD_TYPES.DATETIME &&
        selectedField.value
      ) {
        date = new Date(parseInt(selectedField.value) * 1000)
        if (_isValidDate(date)) {
          customizedField.value = date
          customizedField.value_time = date
        } else {
          customizedField.value = new Date()
          customizedField.value_time = customizedField.value
        }
      } else {
        customizedField.value = selectedField.value
      }
    }

    function _isValidDate(date) {
      return (
        Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date)
      )
    }

    function _getSelectFields(vm) {
      var selectFields = vm.select.available_fields
      _.each(vm.select.additional_fields, function (additionalField) {
        selectFields = _.without(selectFields, additionalField.field)
      })

      return selectFields
    }

    function _getNextAvailableField(vm) {
      var availableField = undefined
      if (vm.select.available_fields.length > 0) {
        var selectFields = _getSelectFields(vm)
        availableField = selectFields[0]
      }
      return availableField
    }

    function addJiraBugtracker(bugtracker) {
      return BugtrackerFactory.addJiraBugtracker(bugtracker)
        .then(function (response) {
          ServiceUtils.logSuccess(response)
          $location.path(UserService.buildUrl('/settings/integration'), true)
        })
        .catch(ServiceUtils.handleError)
    }

    function testJiraBugtracker(bugtracker) {
      return BugtrackerFactory.testJiraBugtracker(bugtracker)
        .then(function (response) {
          return response.data.settings
        })
        .catch(function (response) {
          return $q.reject(response.data)
        })
    }

    function editJiraBugtracker(id, bugtracker) {
      return BugtrackerFactory.editJiraBugtracker(id, bugtracker)
        .then(function (response) {
          ServiceUtils.logSuccess(response)
          $location.path(UserService.buildUrl('/settings/integration'), true)
        })
        .catch(ServiceUtils.handleError)
    }

    function testExistingJiraBugtracker(id, bugtracker) {
      return BugtrackerFactory.testExistingJiraBugtracker(id, bugtracker)
        .then(function (response) {
          return response.data.settings
        })
        .catch(function (response) {
          return $q.reject(response.data)
        })
    }

    function buildJiraBugtrackerBaseProperties(bugtracker, select) {
      var properties = {}
      properties.project = _.find(select.projects, {
        id: bugtracker.project
      })
      properties.priority_critical = _.find(select.priorities, {
        name: bugtracker.priority_critical
      })
      properties.priority_high = _.find(select.priorities, {
        name: bugtracker.priority_high
      })
      properties.priority_medium = _.find(select.priorities, {
        name: bugtracker.priority_medium
      })
      properties.priority_low = _.find(select.priorities, {
        name: bugtracker.priority_low
      })
      properties.priority_note = _.find(select.priorities, {
        name: bugtracker.priority_note
      })
      return properties
    }

    function buildJiraBugtrackerProperties(bugtracker, select) {
      var properties = {}
      properties.assignee = _.find(select.assignees, {
        key: bugtracker.assignee
      })
      properties.issue_type = _.find(select.issue_types, {
        id: parseInt(bugtracker.issue_type)
      })
      return properties
    }

    function addJiraIntegration(data, properties) {
      data.assignee = properties.assignee.key
      data.bugtracker_issue_type = properties.issue_type.id
      if (properties.issue_type.priority_field_available) {
        data.priority = properties.priority.id
      }
      data.fields = []
    }

    function buildJiraIntegration(model, properties) {
      var request = {}
      request.name = model.name
      if (model.username && model.host) {
        request.credentials = {}
        request.credentials.name = model.credentials
          ? model.credentials.name
          : model.name + ' credentials'
        request.credentials.username = model.username
        request.credentials.password = model.password
        request.credentials.host = model.host
      }
      request.credentials_id = model.credentialsId
        ? model.credentialsId
        : undefined

      if (model.all_applications) {
        request.applications = []
      } else {
        request.applications = _.map(model.applications, 'app_id')
      }

      request.all_applications = model.all_applications

      request.importance = _.map(model.importance, 'value')
      request.app_criterion = model.app_criterion

      //build auto create tickets request part
      request.auto_create_tickets_enabled = model.auto_create_tickets_enabled
      request.auto_create_tickets_rules = []
      request.auto_create_tickets_severities = []

      if (!model.auto_create_tickets_enabled) {
        request.auto_create_tickets_all_rules = false
      } else {
        if (model.auto_create_tickets_all_rules) {
          request.auto_create_tickets_all_rules = true
        } else {
          _buildRulesRequestSection(request, model)
          request.auto_create_tickets_all_rules = false
        }
      }

      request.project = properties.project.id
      request.assignee = properties.assignee.key
      request.issue_type = properties.issue_type.id
      request.priority_field_available = properties.priorityFieldAvailable

      if (request.priority_field_available) {
        request.priority_critical = properties.priority_critical.name
        request.priority_high = properties.priority_high.name
        request.priority_medium = properties.priority_medium.name
        request.priority_low = properties.priority_low.name
        request.priority_note = properties.priority_note.name
      }

      request.fields = []

      return request
    }

    function buildJiraFields(request, customizedFields, allowEmptyValues) {
      _.each(customizedFields, function (customizedField) {
        if (angular.isDefined(customizedField.field.key)) {
          var field = {
            key: customizedField.field.key,
            type: customizedField.field.schema.type,
            items: customizedField.field.schema.items
          }

          if (customizedField.field.schema.custom) {
            if (
              customizedField.field.schema.custom.endsWith(
                JIRA_FIELD_TYPES.MULTISELECT
              )
            ) {
              field.type = JIRA_FIELD_TYPES.MULTISELECT
            } else if (
              customizedField.field.schema.custom.endsWith(
                JIRA_FIELD_TYPES.MULTICHECKBOXES
              )
            ) {
              field.type = JIRA_FIELD_TYPES.MULTICHECKBOXES
            } else if (
              customizedField.field.schema.custom.endsWith(
                JIRA_FIELD_TYPES.SELECT
              ) &&
              customizedField.field.schema.type !==
                JIRA_FIELD_TYPES.CASCADING_SELECT
            ) {
              field.type = JIRA_FIELD_TYPES.SELECT
            } else if (
              customizedField.field.schema.custom.endsWith(
                JIRA_FIELD_TYPES.MULTIUSERPICKER
              )
            ) {
              field.type = JIRA_FIELD_TYPES.MULTIUSERPICKER
            } else if (
              customizedField.field.schema.custom.endsWith(
                JIRA_FIELD_TYPES.RADIOBUTTONS
              )
            ) {
              field.type = JIRA_FIELD_TYPES.RADIOBUTTONS
            } else if (
              customizedField.field.schema.custom.endsWith(
                JIRA_FIELD_TYPES.USER
              )
            ) {
              field.type = JIRA_FIELD_TYPES.USER
            }
          }

          if (customizedField.field.schema.type === JIRA_FIELD_TYPES.DATE) {
            if (_isValidDate(customizedField.value)) {
              field.value = moment(customizedField.value).format('X')
            } else {
              field.value = undefined
            }
          } else if (
            customizedField.field.schema.type === JIRA_FIELD_TYPES.DATETIME
          ) {
            if (_isValidDate(customizedField.value)) {
              var dateHelper = moment(customizedField.value)
              var timeHelper = moment(customizedField.value_time)

              dateHelper.second(0)
              dateHelper.minute(timeHelper.minute())
              dateHelper.hour(timeHelper.hour())
              field.value = moment(dateHelper).format('X')
            } else {
              field.value = undefined
            }
          } else if (field.type === JIRA_FIELD_TYPES.MULTIUSERPICKER) {
            if (customizedField.values && customizedField.values.length > 0) {
              field.value = _.map(
                customizedField.values,
                JIRA_FIELD_TYPES.ID
              ).join()
            }
          } else if (
            customizedField.value &&
            (!customizedField.values || customizedField.values.length === 0)
          ) {
            field.value = customizedField.value
          } else if (
            customizedField.values &&
            customizedField.values.length > 0
          ) {
            var helper = _.propertyOf(customizedField.values[0])(
              JIRA_FIELD_TYPES.NAME
            )

            if (helper) {
              field.value = _.map(
                customizedField.values,
                JIRA_FIELD_TYPES.NAME
              ).join()
            } else {
              field.value = customizedField.values.join()
            }
          }

          if (field.value || allowEmptyValues) {
            request.fields.push(field)
          }
        }
      })
    }

    function buildJiraIntegrationTest(model, hasPreviousCredentials) {
      var request = {}

      if (!model.name && hasPreviousCredentials) {
        request.name = BUGTRACKER_DEFAULT_TEST_NAME
      } else {
        request.name = model.name
      }

      if (model.username && model.host) {
        request.credentials = {}
        request.credentials.username = model.username
        request.credentials.password = model.password
        request.credentials.host = model.host
        request.credentials.name = model.credentials
          ? model.credentials.name
          : model.name + ' credentials'
      }
      request.credentials_id = model.credentialsId
        ? model.credentialsId
        : undefined

      return request
    }

    function buildJiraTwoWayIntegration(settings, integrations) {
      settings.integrations = integrations.map(function (item) {
        return {
          issueStatus: item.issue_status,
          issueResolution: item.issue_resolution,
          traceStatus: item.trace_status,
          traceSubstatus: item.trace_substatus
        }
      })
    }

    function getUrl(jiraId, isEdit) {
      var getUrlRequest
      if (isEdit) {
        getUrlRequest =
          BugtrackerFactory.createJiraUrlWebhookFromExistingBugtracker(jiraId)
      } else {
        getUrlRequest = BugtrackerFactory.createJiraUrlWebhook()
      }

      return getUrlRequest
        .then(function (response) {
          return response.data.url
        })
        .catch(ServiceUtils.handleError)
    }

    function _buildRulesRequestSection(data, integration) {
      var j, ruleItem
      for (j = 0; j < integration.auto_create_tickets_rules.length; j++) {
        ruleItem = integration.auto_create_tickets_rules[j]
        if (ruleItem.group === FILTER_GROUPS.SEVERITY) {
          data.auto_create_tickets_severities.push(ruleItem.value)
        } else {
          data.auto_create_tickets_rules.push(ruleItem.value)
        }
      }
    }
  }
})()
